import * as t from './actionTypes';
// import type { Report } from './types';

export function receivedFilteredPaginatedReports(data) {
  return {
    type: t.RECEIVED_FILTERED_REPORTS,
    total: data.total,
    reports: data.results,
  };
}

export function fetchFilteredReportError(error) {
  return {
    type: t.FETCH_FILTERED_REPORTS_ERROR,
    error,
  };
}

export function fetchFilteredReportTable(filters) {
  return {
    type: t.FETCH_FILTERED_REPORTS_REQUEST,
    filters,
  };
}

export function updateSelectedReports(checked /*: boolean */, id /*: number */) {
  return {
    type: checked ? t.SELECT_SINGLE_REPORT : t.DESELECT_SINGLE_REPORT,
    id,
  };
}

export function updateAllSelectedReports(checked /*: boolean */) {
  return {
    type: checked ? t.SELECT_ALL_REPORTS : t.DESELECT_ALL_REPORTS,
  };
}

export function deselectAllReports() {
  return {
    type: t.DESELECT_ALL_REPORTS,
  };
}

export function createNewReport(data) {
  return {
    type: t.CREATE_REPORT_REQUEST,
    data: {
      settings: {
        entityView: {
          chartType: 'bar',
        },
        dateTimeView: {
          chartType: 'line',
        },
      },
      ...data,
    },
  };
}

export function reportCreated(data /* : any[] */) {
  return {
    type: t.REPORT_CREATED,
    data,
  };
}

export function createReportError(error) {
  return {
    type: t.CREATE_REPORT_ERROR,
    error,
  };
}

function transformReportsTableToDropdown(reports /*: Report[] */) {
  return reports.map((report, index) => ({
    key: index,
    value: report[0].link,
    text: report[1].name || report[3].name,
  }));
}

export function passReportsList(props /*: Report[] */) {
  // turn list of reports from table into list form
  return {
    type: t.GENERATE_REPORTS_LIST,
    reportsList: transformReportsTableToDropdown(props),
  };
}
